import { User, LogOut, Users, Briefcase, Settings, Bell, HelpCircle } from "lucide-react";
import { useProfile } from "@/hooks/useProfile";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/contexts/AuthContext";
import { useUserRole } from "@/hooks/useUserRole";
import { useNavigate } from "react-router-dom";

export const UserMenu = () => {
  const { user, signOut } = useAuth();
  const { data: userRole } = useUserRole();
  const { data: profile } = useProfile(user?.id);
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="flex items-center space-x-2">
          <User className="h-4 w-4" />
          <span className="hidden md:inline">{profile?.full_name || user.email}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>Mon compte</DropdownMenuLabel>
        <DropdownMenuSeparator />
        
        {userRole === 'seeker' && (
          <>
            <DropdownMenuItem onClick={() => navigate('/trouver-un-mediateur')}>
              <Users className="h-4 w-4 mr-2" />
              Espace Demandeur
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate('/mon-profil')}>
              <User className="h-4 w-4 mr-2" />
              Mon profil
            </DropdownMenuItem>
          </>
        )}
        
        {userRole === 'mediator' && (
          <>
            <DropdownMenuItem onClick={() => navigate('/mediateur/tableau-de-bord')}>
              <Briefcase className="h-4 w-4 mr-2" />
              Tableau de bord
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate('/mediateur/statut')}>
              <Briefcase className="h-4 w-4 mr-2" />
              Statut de vérification
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate('/mediateur/tableau-de-bord?profil=1')}>
              <Settings className="h-4 w-4 mr-2" />
              Modifier mon profil
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate('/mediateur/tableau-de-bord?notifications=1')}>
              <Bell className="h-4 w-4 mr-2" />
              Préférences de notification
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => navigate('/mediateur/comment-ca-marche')}>
              <HelpCircle className="h-4 w-4 mr-2" />
              Comment ça marche ?
            </DropdownMenuItem>
          </>
        )}
        
        {userRole === 'admin' && (
          <DropdownMenuItem onClick={() => navigate('/admin')}>
            <Briefcase className="h-4 w-4 mr-2" />
            Espace Admin
          </DropdownMenuItem>
        )}
        
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={signOut} className="text-destructive">
          <LogOut className="h-4 w-4 mr-2" />
          Déconnexion
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
